import {
    makeStyles } from "../components/ui";
import {
  isEmpty,
  ItemStatus,
  PersonType,
  SizeType
} from "../constants/constant";
import "./uiUtil.css"
import { Box } from "../components/ui";

class uiUtil {

    getStockOptionLabel(option) {
        return (
            <Box
                key={option.id}
                style={{
                    color: option.noStock ? "#ae0001" : "#008744",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0,
                    margin: 0
                }}
            >
                {!isEmpty(option.colorId) && <div
                    style={{
                        width: 20,
                        height: 20,
                        backgroundColor: option.colorDetails.split(" ")[0],
                        border: "1px solid #ccc",
                        borderRadius: 4,
                    }}
                />}
                {!isEmpty(option.colorId) && <p style={{ fontWeight: "bold", fontSize: "14px", margin: 0, padding: 0 }}>{option.colorDetails}</p>}
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Unit: {option.cnvDetails}</p>
                <p style={{ fontWeight: "bold", fontSize: "14px", margin: 0, padding: 0 }}>{option.details}</p>
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Category: {option.catgName}</p>
                {
                    !isEmpty(option.prdType) &&
                    <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Type: {option.prdType}</p>
                }
                <p style={{ fontSize: "11px", margin: 0, padding: 0 }}>{option.tags}</p>
            </Box>

        );
    };

    getInventoryOptionLabel(option) {
        if (isEmpty(option)) {
            return "";
        }
        return (
            <div
                style={{
                    color: "#030303",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0, // Remove padding
                    margin: 0  // Optional: Remove margin if needed
                }}
            >
                {!isEmpty(option.colorId) && (
                    <p style={{ fontSize: 12, margin: 0, color: "#000" }}>
                        {option.colorDetails}
                        <span style={{
                            display: "inline-block",
                            width: "1.2em",
                            height: "1.2em",
                            backgroundColor: option.colorDetails.split(" ")[0],
                            border: "1px solid #ccc",
                            borderRadius: 4,
                            marginLeft: 4,
                            verticalAlign: "middle",
                        }} />
                    </p>
                )}


                <p style={{ fontWeight: "bold", fontSize: "14px", margin: 0, padding: 0 }}>{option.cnvDetails}</p>
                {
                    option.sizeType !== SizeType.None &&
                    <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Size: {option.sizeType}</p>
                }
                {
                    option.personType !== PersonType.None &&
                    <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>To: {option.personType}</p>
                }
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Status: {option.invStatus === ItemStatus.ACTIVE ? "Active" : "In-Active"}</p>
            </div>

        );
    };

    getProductLabel(option) {
        return (
            <div
                style={{
                    color: "#030303",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0, // Remove padding
                    margin: 0  // Optional: Remove margin if needed
                }}
            >

                <p style={{ fontWeight: "bold", color: "#056fc3", fontSize: "14px", margin: 0, padding: 0 }}>Item: {option.prdName}</p>
                <p style={{ fontSize: "14px", margin: 0, padding: 0 }}>Brand: {option.brandName}</p>
                <p style={{ fontSize: "13px", margin: 0, padding: 0 }}>Category: {option.catgName}</p>
                <p style={{ fontSize: "13px", margin: 0, padding: 0 }}>Hsn code: {option.hsnCode}</p>
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Size: {option.inventoryTypeStr}</p>
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Status: {option.itemStatusStr}</p>
            </div>

        );
    };

    getGoldLabel(option) {
        if (!option) {
            return "";
        }
        return (
            <div
                style={{
                    color: "#030303",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0, // Remove padding
                    margin: 0  // Optional: Remove margin if needed
                }}
            >

                <p style={{ fontWeight: "bold", color: "#056fc3", fontSize: "14px", margin: 0, padding: 0 }}>Item: {option.name}</p>
                <p style={{ fontSize: "14px", margin: 0, padding: 0 }}>Brand: {option.brandName}</p>
                <p style={{ fontSize: "13px", margin: 0, padding: 0 }}>Category: {option.catgName}</p>
                {
                    !isEmpty(option.articleNumber) &&
                    <p style={{ fontSize: "13px", margin: 0, padding: 0 }}>Hsn code: {option.articleNumber}</p>
                }
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Size: {option.karatInfo.details}</p>
            </div>

        );
    };

    getKaratLabel(option) {
        if (!option) {
            return "";
        }
        return (
            <div
                style={{
                    color: "#030303",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0, // Remove padding
                    margin: 0  // Optional: Remove margin if needed
                }}
            >

                <p style={{ fontWeight: "bold", color: "#056fc3", fontSize: "14px", margin: 0, padding: 0 }}>HallMark: {option.hallMark}</p>
                <p style={{ fontSize: "14px", margin: 0, padding: 0 }}>Karat/Purity: {`${option.partsGold} (${option.goldPerc}%)`}</p>
            </div>

        );
    };

    getStockInfoOptionLabel(option, added) {
        if (!option) {
            return "";
        }
        if (isEmpty(option.itemId)) {
            return "";
        }
        return (
            <div
                style={{
                    color: added ? "#7f8485" : "#000000",
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0,
                    margin: 0
                }}
            >
                <u><p style={{ fontSize: "12px", margin: 0, padding: 0 }}>{option.freeStock} Stock</p></u>
                <p style={{ fontWeight: "bold", fontSize: "14px", margin: 0, padding: 0 }}>{option.name}</p>
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Details: {option.prdType}</p>
                <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>Price: {option.rates}</p>
                <p style={{ fontSize: "11px", margin: 0, padding: 0 }}>Q:{option.remQuanStr}</p>
                {
                    !isEmpty(option.expiryDate) &&
                    <p style={{ fontSize: "11px", margin: 0, padding: 0, color: "#8c0000" }}>Expired on:{option.expiryDate}</p>
                }
            </div>

        );
    };

    formatLabel(key) {
        return key
            .replace(/_/g, ' ') // Replace underscores with spaces
            .toLowerCase() // Convert to lowercase
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    useStyles = makeStyles({
        input: {
            '& input[type=number]': {
                '-moz-appearance': 'textfield'
            },
            '& input[type=number]::-webkit-outer-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '& input[type=number]::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            }
        },
    });

    todayFormattedDate = new Date().toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    getMatchedQuan(value, defVal = 1) {
        const match = value.match(/\d+(\.\d+)?/);
        return match ? Number(match[0]) : defVal /* not going to come */;
    }

    getNonNumericPart(value) {
        const match = value.match(/^([^=]+)=/); // Match everything before the '='
        return match ? match[1] : ""; // Return the matched part or null if no match
    }

    areMapsEqual(map1, map2) {

        if (map1.size !== map2.size) {
            return false;
        }

        for (const [key, value] of map1) {
            if (!map2.has(key) || JSON.stringify(map2.get(key)) !== JSON.stringify(value)) {
                return false;
            }
        }

        return true;
    };

    speciaCaseMapsEqual(map1, map2) {
        const isMap1 = map1 instanceof Map;
        const isMap2 = map2 instanceof Map;
        if (!isMap1) {
            return true;
        }
        if (!isMap2) {
            return true;
        }
        return this.areMapsEqual(map1, map2);
    };

    getSearchSelectDetails(option) {
        if (!option) {
            return "";
        }
        return (
            <div key={option.billNo}
                style={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word', wordBreak: "break-word",
                    padding: 0,
                    margin: 0
                }}
            >
                <u><p style={{ fontSize: "12px", margin: 0, padding: 0, color: "#8a534e", }}>{option.createdAt}</p></u>
                <p style={{ fontWeight: "bold", fontSize: "14px", margin: 0, padding: 0, color: "#80592f" }}>{option.billNo}</p>
                {
                    !isEmpty(option.custName) && !isEmpty(option.custMob) &&
                    <p style={{ fontSize: "12px", margin: 0, padding: 0, color: "#00333e" }}>Customer: {`${option.custName}-${option.custMob}`}</p>
                }
                {
                    isEmpty(option.custName) && !isEmpty(option.custMob) &&
                    <p style={{ fontSize: "12px", margin: 0, padding: 0, color: "#00333e" }}>Customer: {`${option.custMob}`}</p>
                }
                <p style={{ fontSize: "12px", margin: 0, padding: 0, color: "#00333e" }}>Price: ₹{option.finalPrice}</p>
            </div>

        );
    };

    roundTo(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    };

    displaySearchedRestoProductItem(option, props, baseUrl) {
        return (
            <Box
                component="li"
                key={option.id}
                {...props}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: 1,
                }}
            >
                {/* Image on left if available */}
                {option.productImage && option.productImage.length > 0 ? (
                    <Box
                        component="img"
                        src={`${baseUrl}files/${option.productImage[0]}`}
                        alt={option.name}
                        sx={{
                            width: 40,
                            height: 40,
                            objectFit: "cover",
                            borderRadius: 1,
                            backgroundColor: "#f0f0f0"
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 1,
                            backgroundColor: "#f0f0f0",
                        }}
                    />
                )}

                {/* Name and Price on right */}
                <Box>
                    <Box sx={{ fontWeight: 600 }}>{option.name}</Box>
                    <Box sx={{ fontSize: "0.85rem", color: "gray" }}>
                        ₹ {option.price?.sAmt} {!isEmpty(option.price.name) && "(" + option.price.name + ")"}
                    </Box>
                </Box>
            </Box>
        )
    };

    hideKeyBoard = () => {
        const isMobileOrTablet = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobileOrTablet && document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }
    };

    showHotKeySpan = (hotkey, fontSize = "14px") => {
        if (isEmpty(hotkey)) return null;
        return (
            <span style={{ color: "#892024", fontWeight: "bold", fontSize: fontSize }}>
                {` (Keyboard ${hotkey})`}
            </span>
        );
    };

    showHotKeySpanWithText = (hotkey, text = "", fontSize = "14px") => {
        if (isEmpty(hotkey)) return text;

        return (
            <>
                {text}
                <span style={{ color: "#892024", fontWeight: "bold", fontSize: fontSize }}>
                    {` (Keyboard ${hotkey})`}
                </span>
            </>
        );
    };
    showHotKeySpanWithTextWithoutPreText = (hotkey, text = "", fontSize = "14px") => {
        if (isEmpty(hotkey)) return text;

        return (
            <>
                {text}
                <span style={{ color: "#892024", fontWeight: "bold", fontSize: fontSize }}>
                    {` (${hotkey})`}
                </span>
            </>
        );
    };

    getTodayFormattedDate() {
        return new Date().toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    }

    getSupplierLabel(baseUrl, option) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#030303",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    padding: 0,
                    margin: 0,
                }}
            >
                {/* 👇 Small image on the left */}
                {!isEmpty(option.logo) && (
                    <img
                        src={`${baseUrl}${option.logo}`}
                        alt={option.supplierName}
                        style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "4px",
                            objectFit: "cover",
                            flexShrink: 0,
                        }}
                    />
                )}

                <p
                    style={{
                        fontWeight: "bold",
                        color: "#056fc3",
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                    }}
                >
                    {`${option.supplierName}(${option.supId})`}
                </p>
            </div>
        );
    }


}

const uiUtilInstance = new uiUtil(); // Assign instance to a variable
export default uiUtilInstance; // Export the named instance